export var EVENTS = [
    'init',
    'start',
    'config',
    'beforeDestroy',
    'provide',
    'report',
    'beforeBuild',
    'build',
    'beforeSend',
    'send',
    'beforeConfig',
];
//# sourceMappingURL=types.js.map